import React from 'react';
import PropTypes from 'prop-types';

import CSS from './styles.css';
import { default as BKIcon } from 'Shared/Icons/Bookmark';
import { default as BKOIcon } from 'Shared/Icons/BookmarkOutline';


const BookmarkViews = ({ isBookmarked, handleClick }) => {
  return (
    <div className={ CSS['container'] } onClick={ handleClick } >
      {isBookmarked
        ? <BKIcon title="Bookmark"
            width={ '12' }
            height={ '20' }
            viewBox={ '6 2 12 20' }
            fill={ '#ff8a57' } />
        : <BKOIcon title="Bookmark Outline"
            width={ '12' }
            height={ '20' }
            viewBox={ '6 2 12 20' }
            fill={ '#686868' } />
      }
    </div>
  );

};

BookmarkViews.propTypes = {
  isBookmarked: PropTypes.bool.isRequired,
  handleClick: PropTypes.func
};


export default BookmarkViews;

